var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingsGroupContactsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.368,
    height: 18.465,
    viewBox: "0 0 22.368 18.465",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "group",
    transform: "translate(-852.816 -990.46)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "users",
    transform: "translate(852.316 987.934)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_579",
    "data-name": "Path 579",
    d: "M16.54,20.828V18.885A3.885,3.885,0,0,0,12.655,15H4.885A3.885,3.885,0,0,0,1,18.885v1.943",
    transform: "translate(0 -0.336)",
    fill: "none",
    stroke: "#3e5172",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_77",
    "data-name": "Ellipse 77",
    cx: 3.561,
    cy: 3.561,
    r: 3.561,
    transform: "translate(5.452 3.74)",
    fill: "none",
    stroke: "#3e5172",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_580",
    "data-name": "Path 580",
    d: "M22.914,20.831V18.889A3.885,3.885,0,0,0,20,15.13",
    transform: "translate(-0.546 -0.339)",
    fill: "none",
    stroke: "#3e5172",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_581",
    "data-name": "Path 581",
    d: "M16,3.13a3.885,3.885,0,0,1,0,7.527",
    transform: "translate(-0.431 0.005)",
    fill: "none",
    stroke: "#3e5172",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsGroupContactsIcon);
export default __webpack_public_path__ + "static/media/settings-group-contacts-icon.1a6bb9ca56e999beb33b5cf856e87e39.svg";
export { ForwardRef as ReactComponent };